export function generateEmailOrcamento(orcamento) {
  const itens = orcamento.itens.map(item => {
    return `
    <tr style="font-family: 'Open Sans', sans-serif;">
      <td>${item.id_produto}</td>
      <td>${item.descricao}</td>
      <td>${item.unidade}</td>
      <td>${item.qtde_produto}</td>
      <td>${item.preco_bruto}</td>
      <td>${item.subtotal_bruto}</td>
    </tr>
  `
  });

  const parcelas = orcamento.parcelas.map(parcela => {
    return `
      <div>
        <p class="mb-0">
          <span class="pr-3">${parcela.tipo_documento}</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="pr-3">${parcela.data_vencimento}</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span class="pr-3">${parcela.valor_parcela}</span>
        </p>
      </div>
  `
  });

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet">
      <title>Orçamento #${orcamento.id_interno}</title>
      <style>
        @media only screen and (max-width: 600px) {
          .width100 {
            width: 100%;
            border: none;
          }
        }
      </style>
    </head>
    <body>
      <table cellpadding="0" cellspacing="0" border="0" align="left" width="100%">
        <tr>
          <td>
            <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
                    <tr>
                      <td>
                        <!-- Header Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
                          <tr>
                            <td>
                              <!-- Compnay Table -->
                              <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
                              <tr>
                                <td style="font-family: 'Open Sans', sans-serif;">
                                  <span><strong>${orcamento.empresa.razao_social}</strong></span> <br>
                                  <span><strong>${orcamento.empresa.nome_fantasia}</strong></span> <br>
                                  <span>${orcamento.empresa.cpf_cnpj} ${orcamento.empresa.inscricao_estadual && `- ${orcamento.empresa.inscricao_estadual}`}</span> <br>
                                  <span>${orcamento.empresa.endereco}, ${orcamento.empresa.numero_endereco} - ${orcamento.empresa.complemento}
          ${orcamento.empresa.bairro} ${orcamento.empresa.cidade} ${orcamento.empresa.cep}<span><br>
                                  <span>Tel.: ${orcamento.empresa.telefone} ${orcamento.empresa.fax}</span><br>
                                  <span>E-mail: ${orcamento.empresa.email} ${orcamento.empresa.site}<span>
                                </td>
                              </tr>
                                <tr><td height="20"></td></tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                        <!-- Orçamento Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100" style="text-align: center;">
                          <tr>
                            <td style="font-family: 'Open Sans', sans-serif;">
                              <h3><strong>ORÇAMENTO</strong></h3>
                            </td>
                          </tr>
                        </table>
                        <table cellpadding="5" cellspacing="0" border="1" align="center" width="600" class="width100">
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td>
                              <span><strong>Criado em</strong></span><br>
                              <span>${orcamento.data_emissao}</span>
                            </td>
                            <td>
                              <span><strong>Válido até</strong></span><br>
                              <span>${orcamento.data_validade}</span>
                            </td>
                            <td>
                              <span><strong>Orçamento</strong></span><br>
                              <span>${orcamento.id_interno}</span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <span><strong>Cliente:</strong></span><br>
                              <span>${orcamento.cliente.razao_social}</span>
                            </td>
                            <td>
                              <span><strong>Vendedor:</strong></span><br>
                              <span>${orcamento.vendedor}</span>
                            </td>
                          </tr>
                        </table>
                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>
                        <!-- Produtos Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Cód.</th>
                            <th bgcolor="#ccc">Produto</th>
                            <th bgcolor="#ccc">Und</th>
                            <th bgcolor="#ccc">QTD</th>
                            <th bgcolor="#ccc">Preço</th>
                            <th bgcolor="#ccc">SubTotal</th>
                          </tr>
                          ${itens.join('')}
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td colspan="4"></td>
                            <td style="color: red;"><strong>Desconto</strong></td>
                            <td style="color: red;"><strong>${orcamento.total_desconto}</strong></td>
                          </tr>
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td colspan="4"></td>
                            <td><strong>Total</strong></td>
                            <td><strong>${orcamento.total_produto}</strong></td>
                          </tr>
                        </table>
    
                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>

                        <!-- Parcelas Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Forma de pagamento</th>
                          </tr>
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td>
                              ${parcelas.join('')}
                            </td>
                          </tr>
                        </table>

                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>
                        
                        <!-- Observações Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Observações</th>
                          </tr>
                          <tr>
                            <td style="font-family: 'Open Sans', sans-serif;">
                              <span>${orcamento.observacoes}</span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>
  `;
}